var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiTec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.927,
    height: 37.339,
    viewBox: "0 0 200.927 37.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(41.222 1.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M643.163,40.569h0V39.45h.981c.487,0,.892.062.892.55,0,.675-.726.569-1.263.569Zm1.252.464h0c.664-.016,1.182-.3,1.182-1.018a.956.956,0,0,0-.409-.815,1.871,1.871,0,0,0-.931-.175H642.6v3.719h.56V41.033h.672l1.081,1.711h.63Zm-.545,3.177h0a3.317,3.317,0,1,0-3.4-3.349,3.351,3.351,0,0,0,3.4,3.349m0-6a2.677,2.677,0,1,1-2.75,2.655,2.7,2.7,0,0,1,2.75-2.655",
    transform: "translate(-487.534 -37.317)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M643.163,40.569h0V39.45h.981c.487,0,.892.062.892.55,0,.675-.726.569-1.263.569Zm1.252.464h0c.664-.016,1.182-.3,1.182-1.018a.956.956,0,0,0-.409-.815,1.871,1.871,0,0,0-.931-.175H642.6v3.719h.56V41.033h.672l1.081,1.711h.63Zm-.545,3.177h0a3.317,3.317,0,1,0-3.4-3.349,3.351,3.351,0,0,0,3.4,3.349m0-6a2.677,2.677,0,1,1-2.75,2.655,2.7,2.7,0,0,1,2.75-2.655",
    transform: "translate(-487.534 -37.317)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M196.062,71.774H185.876l6.656-13.04H184.69l-6.66,13.04H167.855l17.074-33.538H195.1L188.8,50.617h7.854l6.3-12.381h10.163Z",
    transform: "translate(-167.855 -37.76)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M280.7,71.774H270.435l17.07-33.538h10.275Z",
    transform: "translate(-237.241 -37.76)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M345.079,84.266h-10.1l4.126-8.116h10.1Z",
    transform: "translate(-280.901 -63.292)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M368.374,71.774h-9.7L371.662,46.3h-6.98l4.106-8.066h23.5L388.176,46.3H381.35Z",
    transform: "translate(-296.93 -37.76)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M443.851,71.774H418.916L435.99,38.236h24.947L457,45.962H442.036l-2.488,4.893h12.115l-3.813,7.481h-12.11l-2.774,5.423h14.961Z",
    transform: "translate(-337.675 -37.76)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M548.762,58.562c-4.562,7.75-12.686,12.717-20.338,12.717-9.974,0-11.5-7.274-6.636-16.806,4.937-9.691,13.617-17.7,24.074-17.7,8.487,0,10.735,5.076,7.158,13.434l-9.738.5c1.522-2.838,2.279-6.417-1.155-6.417-4.508,0-8.267,7-9.87,10.179-1.727,3.372-4.438,9.095.155,9.095,3.145,0,5.79-2.791,7.339-5.578Z",
    transform: "translate(-405.451 -36.778)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M68.215,57.751h-4.5s-2.974-4.818-7.911-6.128a17.346,17.346,0,0,1,5.563,6.128H56.753S53.771,51.743,44,47.771H77.335a18.71,18.71,0,1,0,.143,3h-16.4s5.512,2.78,7.139,6.982",
    transform: "translate(-40.467 -31.526)",
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiTec);
export default __webpack_public_path__ + "static/media/hi-tec.87fb0fc2cd3c1e9b7ecb3c7cf904708b.svg";
export { ForwardRef as ReactComponent };